import { Outlet } from "react-router-dom";
import EvaluationDocumentHeader from "./evaluationHeader";

const Evaluation = () => {
  return (
    <>
      <EvaluationDocumentHeader />
      <Outlet />
    </>
  );
};

export default Evaluation;
